import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {Order} from "../../app/classes/order";
import {Http} from "@angular/http";
import {AppRate, InAppBrowser} from 'ionic-native';
import {
  CUSTOMER_ANDROID_APP_ID,
  CUSTOMER_IOS_APP_ID,
  CUSTOMER_NAME,
  CUSTOMER_NAME_FULL,
  CUSTOMER_PHONENUMBER
} from "../../app/constants/config";
import {Cart} from "../../app/classes/cart";
import {CartService} from "../../app/services/cart.service";
import {UserService} from "../../app/services/user.service";
import {API} from "../../app/services/api.service";
import {Customer} from "../../app/classes/customer";

@Component({
  selector: 'page-order-submit',
  templateUrl: 'order-submit.html',
  providers: [
    CartService, UserService]
})
export class OrderSubmitPage {
  public order?: Order;
  public cart?: Cart;
  public phonenumber = CUSTOMER_PHONENUMBER;
  public submitted?: boolean = true;
  public orderSuccessful : boolean = false;
  public received?: boolean = false;
  public checkInterval: any;
  public isPaymentLoading: any = false;
  public failedReceivedStatuses = 0;
  public customer: Customer;
  public expectedDelivery: string = "45 Minuten";

  constructor(public api: API, public http: Http, public navCtrl: NavController, public cartService: CartService, public viewCtrl: ViewController, public navParams: NavParams) {
    this.cart = cartService.getCart();
    this.order = new Order(navParams.get("order"));

    this.checkStatus();
    this.checkInterval = setInterval(() => {
      this.checkStatus();
    }, 3000);

    this.customer = Customer.cachedOrCreate(this.http) as Customer;
    this.orderSuccessful = false;
  }



  async initPaypal() {
    if (typeof (window as any).paypal === "undefined" && !document.querySelector("#paypal_loader")) {
      const script = document.createElement("script");
      script.id = "paypal_loader";
      script.src = `https://www.paypal.com/sdk/js?client-id=${this.customer.paymentProviders.paypal.client_id}&currency=EUR&merchant-id=${this.customer.paymentProviders.paypal.merchant_id}&intent=authorize`;
      script.dataset.merchantId = `${this.customer.paymentProviders.paypal.merchant_id},${this.customer.paymentProviders.paypal.email}`;
      console.log(`${this.customer.paymentProviders.paypal.merchant_id},${this.customer.paymentProviders.paypal.email}`);
      script.onload = () => {
        this.initPaypal();
      }

      document.body.appendChild(script);
      return;
    }


    if (!(window as any).paypal) {
      return;
    }

    const wrapper = document.body.querySelector("#paypal-wrapper");
    const wrapperElement = document.createElement("div");
    wrapperElement.id = "paypal-wrapper-element";
    wrapper.appendChild(wrapperElement);

    try {
      (window as any).paypal.Buttons({
        env: "production",
        client: {
          production: this.customer.paymentProviders.paypal.client_id
        },
        style: {
          label: "checkout",
          size: "medium",
          shape: "rect",
          color: "blue",
          tagline: false,
        },
        onReady: () => {
        },
        createOrder: (data, actions) => {
          return new Promise((resolve, reject) => {
            this.http.post(this.order.paymentUrl, {}).subscribe(
              (res) => {
                resolve(res.json().id);
              },
              err => {
                console.error(err);
                reject(err);
              });
          });
        },
        onApprove: (data, actions) => {
          this.isPaymentLoading = true;
          return new Promise((resolve, reject) => {
            this.http.post(this.order.paymentUrl, {
              ...data
            }).subscribe(
              (res) => {
                this.isPaymentLoading = true;
                resolve(res.json());
                this.checkStatus();
              },
              err => {
                reject(err);
              });
          });
        },
        onError: async (err) => {
          console.log(err);
          this.isPaymentLoading = false;
          this.handleFailure();
        }
      }).render("#paypal-wrapper-element");
    } catch (e){
      this.handleFailure();
    }

  }

  call(number) {
    let browser = new InAppBrowser("tel:" + number, '_system');
  }

  setCustomer(customer: Customer) {
    this.customer = customer;
  }

  checkStatus() {
    this.http.get(this.order.url).map(this.parseOrderStatus).subscribe(
      result => this.handleStatus(result),
      err => this.handleError(err)
    )
  }

  exit() {
    this.navCtrl.pop();
  }

  parseOrderStatus(result) {
    return result.json();
  }

  handleStatus(res) {
    this.order = new Order(res);
    if (this.order.status === "completed") {
      clearInterval(this.checkInterval);
      this.orderSuccessful = true;
    } else if (this.order.status === "rejected") {
      this.handleFailure();
      clearInterval(this.checkInterval)
    } else {
      if (this.order.paymentStatus === "completed") {
        this.failedReceivedStatuses += 1;
      }

      if (this.failedReceivedStatuses >= 15) {
        this.handleFailure();
        // refund serverside
        clearInterval(this.checkInterval);
      }
    }
  }

  handleFailure() {
    console.log("failure");
    clearInterval(this.checkInterval);
    // TODO: refund?, delay/wait another 5mins
    this.http.get(this.order.methods.reject as string).map(this.parseOrderStatus).subscribe(
      result => this.viewCtrl.dismiss(false),
      err => {
        console.log(err);
        this.viewCtrl.dismiss(false)
      }
    );
  }

  handleError(err) {
    clearInterval(this.checkInterval);
    if (err.status === 404) {
      alert("Das hat nicht geklappt. Bitte versuche es erneut");
      this.handleFailure();
      this.viewCtrl.dismiss(false);
    }
    console.error(err);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OrderSubmitPage');
    if (this.order.paymentMethod === "paypal") {
      this.initPaypal();
    }
  }

  ionViewWillLeave() {
    if (this.received || this.orderSuccessful) {
      this.viewCtrl.dismiss(true);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/order-submit/order-submit.ts